import React from "react";

import cloneDeep from "lodash/cloneDeep";

import Table from "@cloudscape-design/components/table";
import Pagination from "@cloudscape-design/components/pagination";
import Header from "@cloudscape-design/components/header";
import Input from "@cloudscape-design/components/input";
import Button from "@cloudscape-design/components/button";
import Box from "@cloudscape-design/components/box";
import Grid from "@cloudscape-design/components/grid";
import Badge from "@cloudscape-design/components/badge";
import Preferences from "@cloudscape-design/components/collection-preferences";
import Alert from "@cloudscape-design/components/alert";
import Spinner from "@cloudscape-design/components/spinner";
import Select from "@cloudscape-design/components/select";

/* Recoil */
import { useRecoilValue, useSetRecoilState } from "recoil";
import { configStore } from "../stores/config";
import SpaceBetween from "@cloudscape-design/components/space-between";
import { playerModalStore } from "../stores/playerModal";
import { bonusesStore } from "../stores/bonuses";
import { bonusesAddModalStore } from "../stores/bonusesAddModal";
import { FortuneWheelStore } from "../stores/banners";
import { bannersStore } from "../stores/banners";
import ProgressiveImage from "react-progressive-graceful-image";
import Poster from "../assets/poster.png";
import { BannersAddModal, bannersAddModalStore, BannersAddModalStore } from "../stores/bannersAddModal";
import bannersEditModal from "./BannersEditModal";
import { bannersEditModalStore, BannersEditModalStore } from "../stores/bannersEditModal";
/* ------- */

class Banners extends React.Component {
	constructor(props) {
		super(props);
	}

	getBooleanValue = (value) => {
		if (typeof value === "string") {
			const normalizedValue = value.trim().toLowerCase();
			return normalizedValue === "1" || normalizedValue === "true";
		}

		return value === true || value === 1;
	};

	getRequireTgValue = (item) => {
		if (typeof item.skipLinkTg !== "undefined") return this.getBooleanValue(item.skipLinkTg);
		if (typeof item.skip_link_tg !== "undefined") return this.getBooleanValue(item.skip_link_tg);
		if (typeof item.requireTg !== "undefined") return this.getBooleanValue(item.requireTg);
		return this.getBooleanValue(item.require_tg);
	};

	getRequireEmailValue = (item) => {
		if (typeof item.skipLinkEmail !== "undefined") return this.getBooleanValue(item.skipLinkEmail);
		if (typeof item.skip_link_email !== "undefined") return this.getBooleanValue(item.skip_link_email);
		if (typeof item.requireEmail !== "undefined") return this.getBooleanValue(item.requireEmail);
		return this.getBooleanValue(item.require_email);
	};



	handleKeyPress = (event) => {
		if (event.detail.key === "Enter") {
			setTimeout(() => {
				this.props.Interface.loadBannerList();
			}, 0);
		}
	};


	handleInputDebounceChange = (input, type) => {
		this.props.setBanners({
			...this.props.banners,
			currentSearch: input.detail.value,
			pagination: {
				...this.props.banners.pagination,
				current: 1,
			}
		});

		if (input.detail.value.length === 0) {
			setTimeout(() => this.props.Interface.loadBannerList(), 250)
		}
	};
	componentDidMount() {
		this.props.Interface.loadBannerList();
	}



	render() {
		return (
			<>
				{this.props.banners.loaded && this.props.banners.error.text.length ? (
					<Box
						margin={{ bottom: "m" }}
						children={
							<Alert
								type="error"
								header="Error loading data:"
								children={
									<>
										<Box variant="p" children={this.props.banners.error.text} />
										<hr />
										<Box
											variant="p"
											children={
												<>
													request error code: {this.props.banners.error.code} | request timestamp: {this.props.banners.error.timestamp}
												</>
											}
										/>
									</>
								}
							/>
						}
					/>
				) : (
					<></>
				)}

				<Table
					stickyHeader="true"
					trackBy="id"
					loading={!this.props.banners.loaded}
					sortingColumn={{ sortingField: this.props.banners.sorting.sortingColumn.column }}
					sortingDescending={this.props.banners.sorting.isDescending}
					onSortingChange={(sorting) => {
						this.props.setBanners({ ...this.props.banners, sorting: {
								...this.props.banners.sorting,
								sortingColumn: {
									order: !sorting.detail.isDescending ? "ASC" : "DESC",
									column: sorting.detail.sortingColumn.sortingField
								},
								isDescending: sorting.detail.isDescending,
							} });

						setTimeout(() => {
							this.props.Interface.loadBannerList();
						}, 250);
					}}
					columnDefinitions={[
						{
							width: 20,
							id: "id",
							header: "ID",
							sortingField: "id",
							cell: (item) => (
								<Button
									iconName={"status-in-progress"}
									className={[this.props.styles["btnUID"], typeof document.body.classList[0] !== "undefined" ? this.props.styles["dark"] : "", this.props.styles["blue"]].join(" ")}
									variant="normal"
									onClick={() => {
										setTimeout(() => {
											this.props.setBannersEditModal({
												...this.props.bannersEditModal,
												show: true,
												id: item.id,
												image: item.image,
												title: item.title || "",
												titleType: {value: item.titleType, label: item.titleType} || null,
												buttonText: item.buttonText || "",
												buttonTextType: {value: item.buttonTextType, label: item.buttonTextType} || null,
												buttonType: {value: item.buttonType, label: item.buttonType}  || null,
												link: item.link || "",
												linkType: {value: item.linkType, label: item.linkType}  || null,
												badge: item.badge || "",
												badgeType: {value: item.badgeType, label: item.badgeType}  || null,
												personalization: item.personalization || false,
												description: item.description || "",
												descriptionDefault: item.descriptionDefault || "",
												descriptionType: {value: item.descriptionType, label: item.descriptionType} || null,
												descriptionDefaultType: {value: item.descriptionDefaultType, label: item.descriptionDefaultType} || null,
												analyticsID: item.analyticsID || "",
												requireAuth: item.requireAuth.toString() || "",
												requireTg: this.getRequireTgValue(item),
												requireEmail: this.getRequireEmailValue(item),
												order: item.order.toString() || "",
												from: item.from || "",
												to: item.to || "",
												active: {value: item.active, label: item.active} || null,
											});
										}, 0);
									}}
									children={item.id}
								/>
							),
						},
						{
							width: 70,
							id: "bigPoster",
							header: "image",
							sortingField: "image",
							cell: (item) => (
								<ProgressiveImage src={item.image} placeholder={Poster}>
									{(src) => <img style={{ width: "70px" }} src={src} alt={item.name} />}
								</ProgressiveImage>
							),
						},
						{ id: "title", header: "Title", sortingField: "title", cell: (item) => item.title },
						{ id: "link", header: "Link", sortingField: "link", cell: (item) => item.link },
						{ id: "order", header: "Order", sortingField: "order", cell: (item) => item.order },
						{
							id: "active",
							header: "Active",
							sortingField: "active",
							cell: (item) => item.active,
						},
						{
							id: "require_tg",
							header: "Skip link TG",
							cell: (item) => (
								this.getRequireTgValue(item) ? 1 : 0
							),
						},
						{
							id: "require_email",
							header: "Skip link Email",
							cell: (item) => (
								this.getRequireEmailValue(item) ? 1 : 0
							),
						},
						{ id: "from", header: "From", sortingField: "from", cell: (item) => <>{new Date(item.from).toLocaleDateString() + " " + new Date(item.from).toLocaleTimeString()}</> },
						{ id: "to", header: "To", sortingField: "to", cell: (item) => <>{new Date(item.to).toLocaleDateString() + " " + new Date(item.to).toLocaleTimeString()}</> },
					]}
					items={this.props.banners.data}
					pagination={
						<Pagination
							disabled={!this.props.banners.loaded}
							currentPageIndex={this.props.banners.pagination.current}
							pagesCount={this.props.banners.pagination.total}
							onChange={(page) => {
								this.props.setBanners({ ...this.props.banners, pagination: { ...this.props.banners.pagination, current: page.detail.currentPageIndex } });
								setTimeout(() => {
									this.props.Interface.loadBannerList();
								}, 250)
							}}
						/>
					}
					preferences={
						<Preferences
							cancelLabel="Cancel"
							confirmLabel="Confirm"
							pageSizePreference={{ title: "Logs per page", options: this.props.config.banners.preferences.perPage }}
							preferences={{ pageSize: this.props.config.banners.perPage }}
							title="Preferences"
							onConfirm={(preferences) => {
								localStorage.setItem("banners.perPage", preferences.detail.pageSize);
								this.props.setConfig({ ...this.props.config, banners: { ...this.props.config.banners, perPage: preferences.detail.pageSize } });

								setTimeout(() => {
									this.props.Interface.loadBannerList();
								}, 250);
							}}
						/>
					}
					filter={
						<Box
							margin={{ bottom: "m" }}
							children={
								<Grid
									gridDefinition={[{ colspan: 3 }, { colspan: 3 }, { colspan: 3 }, { colspan: 3 }]}
								/>
							}
						/>
					}
					header={<Box
						margin={{ bottom: "m" }}
						children={
							<Header
								children="Banners"
								counter={
									<>
										({this.props.banners.pagination.count})
									</>
								}
								actions={
									<SpaceBetween direction="horizontal" size="l">
										<Button
											disabled={!this.props.banners.loaded}
											className={[this.props.styles["players-search-button"], this.props.styles["btn"]].join(" ")}
											onClick={() => {
												setTimeout(() => {
													this.props.setBannersAddModal({ ...this.props.bannersAddModal, show: true });
												}, 0);
											}}
											variant="primary"
											children="Add banner"
										/>
									</SpaceBetween>
								}
							/>
						}
					/>}
					empty="No banners found with requested filter"
				/>
			</>
		);
	}
}

function withRecoil(Component) {
	return function WrappedComponent(props) {
		const banners = useRecoilValue(bannersStore);
		const setBanners = useSetRecoilState(bannersStore);
		const config = useRecoilValue(configStore);
		const setConfig = useSetRecoilState(configStore);


		const bannersEditModal = useRecoilValue(bannersEditModalStore);
		const setBannersEditModal = useSetRecoilState(bannersEditModalStore);
		const bannersAddModal = useRecoilValue(bannersAddModalStore);
		const setBannersAddModal = useSetRecoilState(bannersAddModalStore);
		return <Component {...props} bannersEditModal={bannersEditModal} setBannersEditModal={setBannersEditModal} bannersAddModal={bannersAddModal} setBannersAddModal={setBannersAddModal} banners={banners} setBanners={setBanners} config={config} setConfig={setConfig}  />;
	};
}

export default withRecoil(Banners);
